<template>
  <div class="app-cards">
    <v-container>

      <v-card class="mt-8">
        <v-row>
          <v-col cols="12" md="6" sm="6">
            <div class="pa-10">
              <img class="img-fluid" src="../assets/img/vector-1.png">
            </div>
          </v-col>
          <v-col class="d-flex justify-center align-center" cols="12" md="6" sm="6">
            <div class="pa-5">
              <h2 class="text-center"> Nuestra App </h2>
              <hr class="hr-k my-8">
              <p> La app Kefuri consiste en un sistema automático de aviso de posible donante de órganos desde el personal profesional del Servicio de Urgencia (SU) y de la Unidad de Cuidados Intensivos (UCI) hacia la Unidad o Coordinadora Local de Procuramiento (CLP). </p>
            </div>
          </v-col>
        </v-row>
        <h3 class="text-red text-center mt-5">¿En qué consiste?</h3>
        <v-row>
          <v-col cols="12" sm="6" md="4" class="pa-16">
            <h4 class="pl-8">1. Generar alerta</h4>
            <img class="img-fluid" src="../assets/img/app/alerta.png">
            <p class="pl-8">Crea una <b> alerta de posible donante </b> ingresando todos los datos solicitados.</p>
          </v-col>
          <v-col cols="12"  sm="6" md="4" class="pa-16">
            <h4 class="pl-8">2. Alertas activas</h4>
            <img class="img-fluid" src="../assets/img/app/alerta_2.png">
            <p class="pl-8">Revisa las alertas generadas de los posibles donantes, dentro de ellas encontrarás un detallado informe médico. </p>
          </v-col>
          <v-col cols="12"  sm="6" md="4" class="pa-16">
            <h4 class="pl-8">3. Notificación de alertas</h4>
            <img class="img-fluid" src="../assets/img/app/alerta_3.png">
            <p class="pl-8">Llegará una notificación y llamado telefónico a todo el personal médico, enfermería de procuramiento y UCI de turno, indicando sobre un nuevo posible donante. </p>
          </v-col>
        </v-row>
      </v-card>

      <v-card class="mt-8" v-for="(card, index) in cards" :key="index">
        <v-row :class="[card.direction]">
          <v-col md="6" sm="6">
            <div class="pa-5">
              <v-img :src="card.src"></v-img>
            </div>
          </v-col>
          <v-col class="d-flex text-center align-center" md="6" sm="6">
            <div class="pa-5">
              <h2> {{card.title}} </h2>
              <hr class="hr-k my-8">
              <p> {{card.text}} </p>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
  </div>
</template>

<script>

export default {
  name: 'AppCards',
  data() {
    return {
      cards: [
      { src: require('../assets/img/procuramiento.png') , direction: 'flex-row-reverse', title: '¿A quién va dirigida?', text: 'Kefuri está dirigida a toda aquella institución de alta o mediana complejidad, hospitales, servicios de salud o clínicas, que quieran aumentar su cantidad de donantes de órganos para trasplante y mejorar su indicador tanto de notificación como de donantes.'},
      { src: require('../assets/img/hospital.png') , direction: 'flex-row', title: '¿Quiénes usan Kefuri?', text: ' Médicos y enfermeras de Servicios de Urgencia y Unidad de Paciente Crítico o Intensivo para alertar de posibles donantes, y enfermeras y médicos de Procuramiento para recibir las notificaciones e ingresar a seguimiento temprano aquellos pacientes posibles donantes de órganos.'},
      ]}
  },
}
</script>

<style lang="sass" scoped>
  .app-cards
    .hr-k
      width: 50%
    h2
      color: $primary-color
</style>